import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { DropdownListOption } from "../../../../shared/components/search-dropdown/search-dropdown.component";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { TaxYearsService } from "../../../../shared/util/tax-years.service";
import { TaxReturnTypeSubTypeService } from "../../../../shared/util/tax-return-type-subtype.service";
import { Subscription } from "rxjs";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";
import { ConfigStateService } from "../../../config/config-state.service";
import { TranslocoService } from "@jsverse/transloco";
import { SmartFormTypeService } from "../../../../../swaggerServices";

@Component({
    selector: "app-smart-form-select",
    templateUrl: "./smart-form-select.component.html",
    styleUrls: ["./smart-form-select.component.scss"],
    standalone: false
})
export class SmartFormSelectComponent implements OnInit {
  taxYearOptions: DropdownListOption[];
  smartFormTypeOptions: DropdownListOption[];

  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  taxYear: UntypedFormControl;
  smartFormType: UntypedFormControl;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  smartFormAlias: string;
  yearLabel: string;
  previousTaxYearValue: number;

  constructor(
    private taxYearsService: TaxYearsService,
    private typeService: TaxReturnTypeSubTypeService,
    private smartFormService: SmartFormTypeService,
    private config: ConfigStateService,
    private translocoService: TranslocoService,
    private cd: ChangeDetectorRef
  ) {}

  filterSmartFormOptionsByYear(taxYear): void {
    this.smartFormService.getSmartFormTypes().subscribe(result => {
      this.smartFormTypeOptions = result?.smartForms
        .filter(sf => sf?.year === taxYear)
        .map((sf, i) => {
          return {
            id: sf?.id,
            name: sf?.name,
            value: sf?.id?.toString(),
            order: i
          };
        });
      const [firstOption] = this.smartFormTypeOptions;
      if (this.smartFormType) {
        // The smartFormType control already exists, so just update its value
        this.smartFormType.setValue(firstOption?.value);
      } else {
        // The smartFormType control doesn't exist yet, so create it and add it to the form group
        this.smartFormType = new UntypedFormControl(firstOption?.value);
        this.searchForm.addControl("smartFormType", this.smartFormType);
      }
      this.previousTaxYearValue = taxYear;
      this.cd.detectChanges();
    });
  }

  ngOnInit() {
    this.taxYear = new UntypedFormControl("");
    this.taxYearsService.getTaxYears().subscribe((years: any) => {
      this.taxYearOptions = years;
      const currYr = this.taxYearsService.getCurrentTaxYear();
      this.taxYear = new UntypedFormControl(currYr);
      this.previousTaxYearValue = this.taxYear.value;
      this.searchForm.addControl("taxYear", this.taxYear);
      this.filterSmartFormOptionsByYear(this.taxYear.value);
      this.cd.detectChanges();
    });

    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.smartFormAlias = this.uiConfig.config.smartFormAlias;
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService
          .selectTranslate("year")
          .subscribe(value => (this.yearLabel = value));
        this.translocoService
          .selectTranslate("smart-form-alias")
          .subscribe(value => (this.smartFormAlias = value));
      }),

      this.searchForm.valueChanges.subscribe(formValues => {
        if (
          formValues?.taxYear?.value &&
          formValues?.taxYear?.value !== this.previousTaxYearValue
        ) {
          this.filterSmartFormOptionsByYear(formValues.taxYear.value);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
